module.exports = __webpack_public_path__ + "media/images/version_merge/countdown_clock-72770f33866841cf9da9ecf80168f272.png";